export const SadFace = ({ width = 51, height = 51, stroke = '#FC2C2C' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25.5" cy="26" r="20.5" stroke={stroke} strokeWidth="3" />
      <path
        d="M16.291 34.186C16.291 34.186 19.7871 30.093 25.7561 30.093C31.7251 30.093 34.198 34.186 34.198 34.186"
        stroke={stroke}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <ellipse
        cx="32.4078"
        cy="19.6046"
        rx="2.30233"
        ry="2.30233"
        fill={stroke}
      />
      <circle cx="18.5933" cy="19.6046" r="2.30233" fill={stroke} />
    </svg>
  );
};
